module.exports = require("@gradecam/tsenum");